// extracted by mini-css-extract-plugin
module.exports = {"main":"OnlineTruckBooking_main__MLfB_"};